export default "__VITE_ASSET__CnTU7NyC__"